export const visit = (vm, at) => {
vm(require("reporting-data/lang/en.lyaml"));
at({ "en": { "reporting-reports": { "deprecation": { "campaignsContactAttribution": "<b>The properties used in this report have been deprecated.</b> Learn more about the <a href=\"https://knowledge.hubspot.com/campaigns/analyze-campaigns#revenue\" target=\"_blank\">new reports</a> available." } } } });
};